<template>
    <div class="gray-back" style="padding:.2rem 0 1rem 0 ;  height: 100%">
        <van-cell-group>
            <van-cell  v-for="(subject,index) in row.subject_list" @click="downloadCert(subject,{})" :key="index" :title="'项目'+(index+1)"   >
                <template #right-icon>
                    <div class="tiny-btn-1" v-if="subject.have_cert">下载证书</div>
                    <div class="tiny-btn-0" v-else>暂无成绩</div>
                </template>
                <template #label>
                    <div>{{subject.subject_name}}</div>
                    <div style="word-break: normal;">
                        运动员:
                        <span  style="color: #111; font-size:14px;padding:6px;white-space: nowrap;display: inline-block" @click.stop="downloadCert(subject,member)" v-for="(member,index) in subject.yundongyuan" :key="index">{{member.name}} </span>
                    </div>
                </template>
            </van-cell>

        </van-cell-group>

        <van-popup v-model="showCert" style="width: 80%; height: auto ; text-align: center">
            <img :src="certUrl"  style="width: 100%; text-align: center; height: auto"  />
            <van-button  v-if="!isApp" style="margin: 10px auto; text-align: center " type="default" round>请长按图片保存</van-button>
            <van-button v-else @click="appDownload" style="margin: 10px auto; text-align: center " type="default" round>点击下载证书</van-button>
        </van-popup>
        <van-overlay :show="loading"    >
        <van-loading type="spinner" v-model="loading" style="text-align: center ; margin-top: 200px;" />
        </van-overlay> 

    <van-action-sheet v-model="showSelect" title="选择证书">
      <van-cell-group>
        <!-- <van-cell title="社区运动会优秀组织单位证书" v-if="row.shequ_cert_url" is-link  @click="shequYouxiuDownload()" /> -->
        <van-cell title="社区运动会优秀组织单位证书" v-if="row.shequ_cert_url" is-link  @click="getShequYouxiuCert()" />
        <van-cell title="全国证书" is-link  @click="shequDownload('')" />
        <van-cell title="省级证书" is-link  @click="shequDownload('province')" />
        <van-cell title="市级证书" is-link  @click="shequDownload('city')" />
      </van-cell-group>
    </van-action-sheet>

 

    <NavFloatShare @show="show_share_panel = true"></NavFloatShare>


    <van-overlay :show="overlayShow" @click="timeChange(1)" lock-scroll/>

    <div class="shareShow" v-if="showWxShare" @click="showWxShare=false">
      <div>
        <h2>点击分享给好友</h2>
      </div>
    </div>

    <van-popup v-model="show_share_panel" position="bottom" :style="{ height: '30%' }">
      <div class="share-panel">
        <div class="share-title">请选择分享方式</div>
        <!--<div class="share-desc">朋友通过你分享的页面成功报名后，你可获得对应的佣金。佣金可在会员中心-分销订单里查看</div>-->
        <div class="share-ul">
          <div class="share-weixin" @click="shareWeixinFriend">
            <p>微信好友</p>
          </div>
          <div class="share-timeline" @click="shareWeixinTimeLine">
            <p>朋友圈</p>
          </div>
          <div class="share-copy" v-clipboard:copy="copy_text"
               v-clipboard:success="function(){copySuccess();show_share_panel=false }">
            <p>复制链接</p>
          </div>
        </div>
      </div>
    </van-popup>
    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }


    .bottom-button{
        margin-top: 0.2rem;
        margin-bottom: 0.2rem;
        width: 100%;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
    }

    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }


    .van-tag {
        margin-right: 10px;
        text-align: center;
    }
    .between {
        justify-content: space-between;
    }


</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';
import NavFloatShare from "@/components/NavFloatShare.vue";

    import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,Icon, Toast, Popup,Overlay, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';

    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Overlay).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'SaiCertList',
        components: {
            PicUploader,NavFloatShare
        },
        data: function () {
            return {
                validator,
                show_share_panel:false,
                overlayShow: false,
                loading:false,
                showSelect:false,
                showCert:false,
                showWxShare:false,
                copy_text:'',
                saveLoading:false,
                showArea:false,
                areaList:{},
                certUrl:'',
                thismember:{},
                filename:'',
                areaValue:'',
                submitType:'',
                thissubject:{},
                share_data:{

                },
                row:{
                    danwei:{

                    },
                    subject_list:[

                    ],
                    shequ_cert_url:''
                },
                formData: {

                },
                isApp:window.isApp()
            }
        },
        filters: {},
        mounted() {
            document.title = '下载';
            let that = this;
            that.row.id = this.$route.query.id;
            that.sid = this.$route.query.sid; 
            that.ssid = this.$route.query.ssid;
            this.fetch(); 
            this.share_data = {
            // desc: "",
            // pic_url: "",
            // title: 'CCA赛事证书下载',
            // url: "https://h5.ccachina.net/cca-h5/dist/isai-cert-list?sid="+that.row.id
            }


            window.rbMessage = function (data) {
            if (data == 'showShare') {
                that.show_share_panel = true;
            }
            }
        },
        watch: {
        },
        destroyed() {
        },
        methods: {
            onQuestion(){
                console.log('onQuestion')
            },
            fetch(){
                let that = this;
                    console.log('that.sid',that.sid)
                let url = '/api/isai/certlist'
                if(that.sid >0){
                     url = '/api/isai/certlistbyshare'
                }
                that.$api.post(url, {
                    id:that.row.id,
                    sid:that.sid,
                    ssid:that.ssid,
                }, (res) => {
                    that.row = res.data;
                    that.share_data = res.data.share_data
                    that.copy_text = that.share_data.url;
                }, (res) => {
                    Toast.fail(res.msg);
                })
            },
            downloadCert(subject,member){
                if(!subject.have_cert){
                    return ;
                }
                let that = this;
                if(this.row.saiqu == 711){
                    if(subject.subject_name.indexOf('活力大课间') > 0){
                        if(!member.id){
                            Toast('活力大课间项目，请点击运动员下载证书');
                            return 
                        }
                        this.thismember = member
                    }else{
                        this.thismember = {}
                    }
                    this.showSelect = true
                    this.thissubject = subject

                    return 
                }
                that.loading = true;
                that.$api.post('/api/sai/getcert', {
                    subject_id:subject.id,
                    type:subject.cert_type,
                }, (res) => {
                    console.log(res);
                    that.loading = false;
                    that.showCert = true;
                    that.certUrl = res.data.url;
                    that.filename = res.data.filename;
                }, (res) => {
                    that.loading = true;
                    Toast.fail(res.msg);
                })
            },
            shequDownload(area_type){
                let filename = ''
                if(this.thismember.id){
                    //运动员证书 大课间
                    filename = 'm'+this.thismember.id+area_type+'.jpg'; 
                }else{
                    filename = this.thissubject.id+area_type+'.jpg'; 
                }
                this.showCert = true;
                this.certUrl = 'https://ccago.oss-cn-hangzhou.aliyuncs.com/sai/cert/score/'+filename+'?r='+Math.random();
                this.filename = filename;
            },
            getShequYouxiuCert(){
                let that = this;
                that.loading = true;
                that.showSelect =false
                that.$api.post('/api/dshequscore/getYouxiuCert', {
                    id:that.thissubject.baoming_id, 
                }, (res) => {
                    console.log(res);
                    that.loading = false;
                    that.showCert = true;
                    that.certUrl = res.data.url;
                    that.filename = res.data.filename;
                }, (res) => {
                    that.loading = true;
                    Toast.fail(res.msg);
                })
            },
            shareWeixinFriend() {
            console.log('shareWeixinFriend')
            let that = this;
            if (window.isApp()) {
                appEvent({
                name: 'shareWeixinFriend',
                query: that.share_data
                });
            } else {
                this.showWxShare = true;
                this.show_share_panel = false;
            }
            },
            shareWeixinTimeLine() {
            let that = this;
            if (window.isApp()) {
                appEvent({
                name: 'shareWeixinTimeLine',
                query: that.share_data
                });
            } else {
                this.showWxShare = true;
                this.show_share_panel = false;

            }
            },
            // shequYouxiuDownload(){  
            //     let that = this;
            //     let filename = 'shequyouxiu.jpg'; 
            //     this.showCert = true;
            //     this.certUrl = that.row.shequ_cert_url;
            //     this.filename = filename;
            // },
            appDownload(){
                let that = this;
                console.log('downloadPic');
                appEvent({
                    name: 'downloadPic',
                    query: {
                        filename: that.filename.replace(".pdf",''),
                        url:that.certUrl,
                    }
                });
            }

        }
    }
</script>



// WEBPACK FOOTER //
// SaiCertList.vue?0c719f89